/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RankedUniversityOption
 */
export interface RankedUniversityOption {
    /**
     * 
     * @type {number}
     * @memberof RankedUniversityOption
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RankedUniversityOption
     */
    yearType: RankedUniversityOptionYearTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RankedUniversityOption
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RankedUniversityOption
     */
    rankType: RankedUniversityOptionRankTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof RankedUniversityOption
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof RankedUniversityOption
     */
    rankInChina?: string;
    /**
     * 
     * @type {string}
     * @memberof RankedUniversityOption
     */
    rankingCountryName: string;
    /**
     * 
     * @type {number}
     * @memberof RankedUniversityOption
     */
    countryId: number;
    /**
     * 
     * @type {boolean}
     * @memberof RankedUniversityOption
     */
    isProject211: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RankedUniversityOption
     */
    isProject985: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RankedUniversityOption
     */
    isUniversityPartner: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RankedUniversityOption
     */
    isDepartmentPartner: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RankedUniversityOption
     */
    isOther: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RankedUniversityOption
     */
    isChina: boolean;
}

/**
* @export
* @enum {string}
*/
export enum RankedUniversityOptionYearTypeEnum {
    _2022 = '_2022',
    _2025 = '_2025',
    _2026 = '_2026'
}/**
* @export
* @enum {string}
*/
export enum RankedUniversityOptionRankTypeEnum {
    Rank = 'rank',
    _201250 = '_201_250',
    _251300 = '_251_300',
    _301350 = '_301_350',
    _351400 = '_351_400',
    _401500 = '_401_500',
    _501600 = '_501_600',
    _601800 = '_601_800',
    _8011000 = '_801_1000',
    _10011200 = '_1001_1200',
    _12011500 = '_1201_1500',
    Above1501 = '_above1501',
    Reporter = 'Reporter',
    NotRanked = 'NotRanked'
}

export function RankedUniversityOptionFromJSON(json: any): RankedUniversityOption {
    return RankedUniversityOptionFromJSONTyped(json, false);
}

export function RankedUniversityOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RankedUniversityOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'yearType': json['yearType'],
        'name': json['name'],
        'rankType': json['rankType'],
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'rankInChina': !exists(json, 'rankInChina') ? undefined : json['rankInChina'],
        'rankingCountryName': json['rankingCountryName'],
        'countryId': json['countryId'],
        'isProject211': json['isProject211'],
        'isProject985': json['isProject985'],
        'isUniversityPartner': json['isUniversityPartner'],
        'isDepartmentPartner': json['isDepartmentPartner'],
        'isOther': json['isOther'],
        'isChina': json['isChina'],
    };
}

export function RankedUniversityOptionToJSON(value?: RankedUniversityOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'yearType': value.yearType,
        'name': value.name,
        'rankType': value.rankType,
        'rank': value.rank,
        'rankInChina': value.rankInChina,
        'rankingCountryName': value.rankingCountryName,
        'countryId': value.countryId,
        'isProject211': value.isProject211,
        'isProject985': value.isProject985,
        'isUniversityPartner': value.isUniversityPartner,
        'isDepartmentPartner': value.isDepartmentPartner,
        'isOther': value.isOther,
        'isChina': value.isChina,
    };
}


